import DialEmoji, { EmojiAngle } from './DialEmoji'

const sectors: EmojiAngle[] = [30, 90, 150, 210, 270, 330]

type Props = {
  stripeWidthPercentage: number
}
export default function RenderEmojis({ stripeWidthPercentage }: Props) {
  return (
    <>
      {sectors.map((angle) => {
        return <DialEmoji angle={angle} stripeWidthPercentage={stripeWidthPercentage} key={angle} />
      })}
    </>
  )
}
